import { useState } from 'react';

interface Props {
  onClose: () => void;
  onGenerated: (count: number, category: string) => void;
}

const GENERATE_CATEGORIES = [
  { id: 'yapay-zeka', name: 'Yapay Zeka', icon: 'ri-robot-line', color: 'bg-violet-100 text-violet-700' },
  { id: 'mobil', name: 'Mobil', icon: 'ri-smartphone-line', color: 'bg-blue-100 text-blue-700' },
  { id: 'oyun', name: 'Oyun', icon: 'ri-gamepad-line', color: 'bg-green-100 text-green-700' },
  { id: 'donanim', name: 'Donanım', icon: 'ri-cpu-line', color: 'bg-orange-100 text-orange-700' },
  { id: 'yazilim', name: 'Yazılım', icon: 'ri-code-line', color: 'bg-cyan-100 text-cyan-700' },
  { id: 'girisimcilik', name: 'Girişimcilik', icon: 'ri-rocket-line', color: 'bg-pink-100 text-pink-700' },
  { id: 'kripto', name: 'Kripto', icon: 'ri-bit-coin-line', color: 'bg-yellow-100 text-yellow-700' },
  { id: 'bilim', name: 'Bilim', icon: 'ri-flask-line', color: 'bg-teal-100 text-teal-700' },
  { id: 'siber-guvenlik', name: 'Siber Güvenlik', icon: 'ri-shield-line', color: 'bg-red-100 text-red-700' },
  { id: 'otomotiv', name: 'Otomotiv', icon: 'ri-car-line', color: 'bg-slate-100 text-slate-700' },
  { id: 'saglik', name: 'Sağlık', icon: 'ri-heart-pulse-line', color: 'bg-rose-100 text-rose-700' },
  { id: 'uzay', name: 'Uzay', icon: 'ri-rocket-2-line', color: 'bg-indigo-100 text-indigo-700' },
  { id: 'fintech', name: 'Fintech', icon: 'ri-bank-line', color: 'bg-emerald-100 text-emerald-700' },
  { id: 'spor-teknolojisi', name: 'Spor Teknolojisi', icon: 'ri-run-line', color: 'bg-lime-100 text-lime-700' },
  { id: 'egitim-teknolojisi', name: 'Eğitim Teknolojisi', icon: 'ri-graduation-cap-line', color: 'bg-amber-100 text-amber-700' },
  { id: 'cevre-enerji', name: 'Çevre & Enerji', icon: 'ri-leaf-line', color: 'bg-green-100 text-green-800' },
  { id: 'drone-robot', name: 'Drone & Robot', icon: 'ri-send-plane-line', color: 'bg-sky-100 text-sky-700' },
  { id: 'metaverse-arvr', name: 'Metaverse & AR/VR', icon: 'ri-glasses-line', color: 'bg-purple-100 text-purple-700' },
  { id: 'yapay-zeka', name: 'Yapay Zeka', icon: 'ri-robot-line', color: 'bg-violet-100 text-violet-700' },
  { id: 'mobil', name: 'Mobil', icon: 'ri-smartphone-line', color: 'bg-blue-100 text-blue-700' },
  { id: 'oyun', name: 'Oyun', icon: 'ri-gamepad-line', color: 'bg-green-100 text-green-700' },
  { id: 'donanim', name: 'Donanım', icon: 'ri-cpu-line', color: 'bg-orange-100 text-orange-700' },
  { id: 'yazilim', name: 'Yazılım', icon: 'ri-code-line', color: 'bg-cyan-100 text-cyan-700' },
  { id: 'girisimcilik', name: 'Girişimcilik', icon: 'ri-rocket-line', color: 'bg-pink-100 text-pink-700' },
  { id: 'kripto', name: 'Kripto', icon: 'ri-bit-coin-line', color: 'bg-yellow-100 text-yellow-700' },
  { id: 'siber-guvenlik', name: 'Siber Güvenlik', icon: 'ri-shield-line', color: 'bg-red-100 text-red-700' },
  { id: 'otomotiv', name: 'Otomotiv', icon: 'ri-car-line', color: 'bg-slate-100 text-slate-700' },
];

const COUNT_OPTIONS = [5, 10, 15, 20, 25];

const EDGE_FUNCTION_URL = 'https://ixduinqmfepnggmheoci.supabase.co/functions/v1/generate-news';

export default function GenerateNewsModal({ onClose, onGenerated }: Props) {
  const [selectedCategory, setSelectedCategory] = useState('');
  const [count, setCount] = useState(10);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [result, setResult] = useState<{ success: boolean; message: string } | null>(null);
  const [error, setError] = useState('');

  const handleGenerate = async () => {
    if (!selectedCategory) {
      setError('Lütfen bir kategori seçin.');
      return;
    }
    setLoading(true);
    setError('');
    setResult(null);
    setProgress(0);

    // Simulate progress
    const interval = setInterval(() => {
      setProgress(p => Math.min(p + 8, 85));
    }, 200);

    try {
      const res = await fetch(EDGE_FUNCTION_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ category: selectedCategory, count }),
      });

      clearInterval(interval);
      setProgress(100);

      const data = await res.json();

      if (!res.ok || data.error) {
        setError(data.error || 'Haber üretimi başarısız oldu.');
        setLoading(false);
        setProgress(0);
        return;
      }

      setResult({ success: true, message: data.message });
      onGenerated(data.inserted, selectedCategory);
    } catch (err) {
      clearInterval(interval);
      setError('Bağlantı hatası. Lütfen tekrar deneyin.');
      setProgress(0);
    } finally {
      setLoading(false);
    }
  };

  const catInfo = GENERATE_CATEGORIES.find(c => c.id === selectedCategory);

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 sticky top-0 bg-white z-10">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 flex items-center justify-center bg-[#0A0E27] rounded-xl">
              <i className="ri-magic-line text-[#00D9FF]" />
            </div>
            <div>
              <h2 className="font-bold text-[#0A0E27] text-base">Otomatik Haber Üret</h2>
              <p className="text-xs text-gray-400">Kategori seç, haber sayısını belirle</p>
            </div>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 cursor-pointer">
            <i className="ri-close-line text-gray-500" />
          </button>
        </div>

        <div className="p-6 flex flex-col gap-6">
          {/* Success Result */}
          {result?.success && (
            <div className="flex items-center gap-3 bg-green-50 border border-green-200 rounded-xl p-4">
              <div className="w-10 h-10 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0">
                <i className="ri-check-line text-green-600 text-xl" />
              </div>
              <div>
                <p className="font-semibold text-green-800 text-sm">{result.message}</p>
                <p className="text-xs text-green-600 mt-0.5">Haberler başarıyla veritabanına eklendi.</p>
              </div>
            </div>
          )}

          {/* Category Selection */}
          <div>
            <label className="block text-sm font-bold text-[#0A0E27] mb-3">
              Kategori Seç <span className="text-red-400">*</span>
            </label>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
              {GENERATE_CATEGORIES.map(cat => (
                <button
                  key={cat.id}
                  type="button"
                  onClick={() => { setSelectedCategory(cat.id); setError(''); }}
                  className={`flex items-center gap-2 px-3 py-2.5 rounded-xl border-2 text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                    selectedCategory === cat.id
                      ? 'border-[#0A0E27] bg-[#0A0E27] text-white'
                      : 'border-gray-200 hover:border-gray-300 text-gray-700'
                  }`}
                >
                  <span className={`w-6 h-6 flex items-center justify-center rounded-md flex-shrink-0 ${
                    selectedCategory === cat.id ? 'bg-white/20' : cat.color
                  }`}>
                    <i className={`${cat.icon} text-xs`} />
                  </span>
                  <span className="truncate">{cat.name}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Count Selection */}
          <div>
            <label className="block text-sm font-bold text-[#0A0E27] mb-3">
              Kaç Haber Üretilsin?
            </label>
            <div className="flex items-center gap-2">
              {COUNT_OPTIONS.map(n => (
                <button
                  key={n}
                  type="button"
                  onClick={() => setCount(n)}
                  className={`flex-1 py-2.5 rounded-xl border-2 text-sm font-bold transition-all cursor-pointer whitespace-nowrap ${
                    count === n
                      ? 'border-[#0A0E27] bg-[#0A0E27] text-white'
                      : 'border-gray-200 text-gray-600 hover:border-gray-300'
                  }`}
                >
                  {n}
                </button>
              ))}
            </div>
            <p className="text-xs text-gray-400 mt-2">Maksimum tek seferde 25 haber üretilebilir.</p>
          </div>

          {/* Preview */}
          {selectedCategory && (
            <div className="bg-gray-50 rounded-xl p-4 flex items-center gap-3">
              <div className={`w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0 ${catInfo?.color}`}>
                <i className={`${catInfo?.icon} text-lg`} />
              </div>
              <div>
                <p className="text-sm font-semibold text-[#0A0E27]">
                  {catInfo?.name} kategorisine <span className="text-[#00D9FF]">{count} haber</span> eklenecek
                </p>
                <p className="text-xs text-gray-400 mt-0.5">
                  Türkçe, 2026 tarihli, özgün içerikler otomatik üretilecek
                </p>
              </div>
            </div>
          )}

          {/* Progress */}
          {loading && (
            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between text-xs text-gray-500">
                <span className="flex items-center gap-1.5">
                  <i className="ri-loader-4-line animate-spin" />
                  Haberler üretiliyor...
                </span>
                <span>{progress}%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className="bg-[#0A0E27] h-2 rounded-full transition-all duration-300"
                  style={{ width: `${progress}%` }}
                />
              </div>
            </div>
          )}

          {/* Error */}
          {error && (
            <div className="flex items-center gap-2 text-sm text-red-500 bg-red-50 rounded-xl px-4 py-3">
              <i className="ri-error-warning-line flex-shrink-0" />{error}
            </div>
          )}

          {/* Actions */}
          <div className="flex gap-3">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 border border-gray-200 text-gray-600 rounded-xl py-3 text-sm font-semibold hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              {result ? 'Kapat' : 'İptal'}
            </button>
            {!result && (
              <button
                type="button"
                onClick={handleGenerate}
                disabled={loading || !selectedCategory}
                className="flex-1 bg-[#0A0E27] text-white rounded-xl py-3 text-sm font-bold hover:bg-[#0A0E27]/80 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50 flex items-center justify-center gap-2"
              >
                {loading ? (
                  <><i className="ri-loader-4-line animate-spin" />Üretiliyor...</>
                ) : (
                  <><i className="ri-magic-line" />Haberleri Üret</>
                )}
              </button>
            )}
            {result && (
              <button
                type="button"
                onClick={() => { setResult(null); setSelectedCategory(''); setCount(10); setProgress(0); }}
                className="flex-1 bg-[#0A0E27] text-white rounded-xl py-3 text-sm font-bold hover:bg-[#0A0E27]/80 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
              >
                <i className="ri-add-line" />Tekrar Üret
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
